/*
example

<div class="js-slider" data-auto-advance="true" data-auto-advance-time="4000">
   <div>
      <span class="js-slider-previous" role="button" aria-label="Previous slide" title="Previous slide"></span>
      <span class="js-slider-next" role="button" aria-label="Next slide" title="Next slide"></span>
   </div>

   <div>
      <div class="js-slider-item"></div>
      <div class="js-slider-item"></div>
      <div class="js-slider-item"></div>
   </div>

   <div class="js-slider-indicators"></div>
</div>


*/

var app = app || {};
( function( $ ) {
   app.slider = new function () {
      var _self = this;
      var _settings = [];

      this.init = function() {
         var $sliders = $('.js-slider');
         if (!$sliders.length ) {
            return;
         }
         $sliders.each(function(index){
            var $slider = $(this);

            var mobileOnly = $slider.attr('data-slider-mobile-only');

            //don't initialize this slider if it's only meant to me a slider in mobile
            if (mobileOnly == 'true' && !app.main.isMobile()) {
               return;
            }

            //give the slider an ID so that we can store settings for it in an array
            $slider.attr('data-slider-id',index);

            if($slider.find('.js-slider-item').length == 1) {
               $slider.find('.js-slider-previous').remove();
               $slider.find('.js-slider-next').remove();
               return;
            }
            //add indicators
            for(var i = 0; i < $slider.find('.js-slider-item').length; i++) {
               $slider.find('.js-slider-indicators').append('<span class="js-slider-toggle" role="button" aria-expanded="false" title="Open slide '+(i+1)+'"></span>');
            }

            //open the first slide
            _self.openSlide($slider, 0);

            _settings[index] = {};
            //if data-auto-advance is set to true, we advance the slider automatically based on the data-auto-advance-time setting
            if ($slider.attr('data-auto-advance') == 'true') {
               _settings[index].autoAdance = true;
               _settings[index].autoAdvanceTime = parseInt($slider.attr('data-auto-advance-time')) * 1000 || 3000;
               _self.runAutoAdvance($slider);
            }



         });

         $(document).on('click', '.js-slider-next', function(){
            var $slider = $(this).parents('.js-slider');
            var $currentActive = $slider.find('.js-slider-item[aria-hidden="false"]');
            var index = $currentActive.index();
            index++;
            _self.stopAutoAdvanceTimer($slider);
            _self.openSlide($slider, index);
         });

         $(document).on('click', '.js-slider-previous', function(){
            var $slider = $(this).parents('.js-slider');
            var $currentActive = $slider.find('.js-slider-item[aria-hidden="false"]');
            var index = $currentActive.index();
            index--;
            _self.stopAutoAdvanceTimer($slider);
            _self.openSlide($slider, index);
         });

         $(document).on('click', '.js-slider-toggle', function(){
            var $slider = $(this).parents('.js-slider');
            var index = $(this).index();
            _self.stopAutoAdvanceTimer($slider);
            _self.openSlide($slider, index);
         });

         //open slide based on hash
         _self.openHashSlide();

         $(window).on('app:contentLoaded.slider', function () {
            _self.openHashSlide();
         });
         $(window).on('hashchange.slider', function () {
            _self.openHashSlide();
         });

      };

      this.openHashSlide = function(){
         if (window.location.hash) {
            var $sliderItem = $(window.location.hash);
            if ($sliderItem.length && $sliderItem.hasClass('js-slider-item')) {
              var $slider = $sliderItem.parents('.js-slider');
               _self.openSlide($slider, $sliderItem.index());
            }
         }
      };

      this.openSlide = function($slider, index) {
        var $items = $slider.find('.js-slider-item');
         if (index < 0) {
            index = $items.length - 1;

         }
         else if (index >= $items.length) {
            index = 0;
         }
         var $item = $slider.find('.js-slider-item:eq('+index+')');
         $items.attr('aria-hidden', 'true');
         $item.attr('aria-hidden', 'false');
        
         $slider.attr('data-slider-align', $item.attr('data-slider-align'));
         this.showOrHideAdvancers($slider);
         _self.activeIndicators($slider);
         $(document).trigger('app:contentChanged');
         app.aria.tabIndex.enableVisible($('body'));
      };

      this.stopAutoAdvanceTimer = function($slider){
         var sliderID = $slider.attr('data-slider-id');
         clearInterval(_settings[sliderID].autoAdanceTimer);
      };
      this.runAutoAdvance = function($slider) {

         var sliderID = $slider.attr('data-slider-id');

         _settings[sliderID].autoAdanceTimer = setInterval(function(){
            var $currentActive = $slider.find('.js-slider-item[aria-hidden="false"]');
            var index = $currentActive.index();
            index++;
            if (index >= $slider.find('.js-slider-item').length) {
               index = 0;
            }
            _self.openSlide($slider, index);

         }, _settings[sliderID].autoAdvanceTime);


      };
      this.activeIndicators = function($slider) {
         //show which indicator should light up

         var $currentActive = $slider.find('.js-slider-item[aria-hidden="false"]');
         if ($currentActive.length) {
            var index = $currentActive.index();
            $slider.find('.js-slider-toggle').attr('aria-expanded', 'false');
            $slider.find('.js-slider-toggle:eq('+index+')').attr('aria-expanded', 'true');
         }
      };

      this.showOrHideAdvancers = function($slider) {
         //show or hide the prev/next advancer depending if there are more slide to the left or right

         var $currentActive = $slider.find('.js-slider-item[aria-hidden="false"]');
         if ($currentActive.length) {
            if ($currentActive.prev().length) {
               $slider.find('.js-slider-previous').attr('aria-hidden', 'false');
            }
            else {
               $slider.find('.js-slider-previous').attr('aria-hidden', 'true');
            }

            if ($currentActive.next().length) {
               $slider.find('.js-slider-next').attr('aria-hidden', 'false');
            }
            else {
               $slider.find('.js-slider-next').attr('aria-hidden', 'true');
            }
         }
      };


   };
   app.slider.init();

})(jQuery);
